import { render, staticRenderFns } from "./pi-content.vue?vue&type=template&id=2ec4200e&scoped=true&"
import script from "./pi-content.vue?vue&type=script&lang=js&"
export * from "./pi-content.vue?vue&type=script&lang=js&"
import style0 from "./pi-content.vue?vue&type=style&index=0&id=2ec4200e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec4200e",
  null
  
)

export default component.exports